export const DEFAULT_LIST_BULK_ADD_FOOTER_HEIGHT = 554;
export const ERRORS_STACK_HEIGHT = 88;
export const ITEM_SPLITTER_REGEX = /[\n,;]/;
export const TEXT_FIELD_HEIGHT = 260;
